import React from 'react';
import { Outlet } from 'react-router-dom';
import ImpersonationBanner from '../components/admin/ImpersonationBanner';

// BAR-40: pathless layout route. Having no `path` (only `element` in
// AppRoutes), React keeps this SAME instance mounted across child route
// changes, so its <Outlet/> subtree is the only thing that reconciles on
// navigation.
//
// As built, the persistent chrome (sidebar / header / canvas frame / chat
// panel / modals) + the ShellUiProvider live in MainApplicationUI, which this
// Outlet renders via the path='*' route in AppRoutes — so the chrome already
// never remounts on navigation. Physically relocating the chrome into this
// component was deliberately NOT done (it's deeply coupled to MainApplicationUI
// state and unverifiable without authed e2e); see the router-overhaul plan's
// "Outcome (as built)". ShellLayout stays a thin Outlet wrapper.
//
// BAR-135: it also hosts the persistent super-admin impersonation banner —
// rendered above the Outlet so it is visible on every authed view while a
// session is active (and self-hides when not impersonating).
export default function ShellLayout() {
  return (
    // h-screen anchors the column to the viewport (the parent Outlet provides no
    // height). The banner (shrink-0, self-hides when not impersonating) reduces
    // the space the shell fills; the shell's root uses h-full to fit the
    // remaining flex-1 area, so nothing is clipped whether or not the banner shows.
    <div className="flex flex-col h-screen overflow-hidden">
      <ImpersonationBanner />
      <div className="flex-1 min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
